export default __webpack_public_path__ + "static/media/sui-logo.1f61384e.png";